import React from "react";
import { Header } from "../components/Header";
import { Footer } from "../components/Footer";
import { DisclosureBanner } from "../components/DisclosureBanner";
import { LegalLayout } from "./LegalLayout";
import { useLegalSEO } from "../lib/useLegalSEO";

const Privacy = () => {
    useLegalSEO({
        title: "Privacy Policy | Better Rest Report",
        description:
            "How SleepComfortReport.com collects, uses, and protects information about visitors. Cookies, affiliate links, and your privacy choices.",
        path: "/privacy",
    });
    return (
    <div className="App">
        <DisclosureBanner variant="top" />
        <Header />
        <LegalLayout
            kicker="Legal"
            title="Privacy Policy"
            updated="Last updated: December 2025"
            testId="page-privacy"
        >
            <p>
                This Privacy Policy describes how SleepComfortReport.com
                ("we," "us," or "our") collects, uses, and discloses
                information about you when you visit or interact with our
                website (the "Site"). By using the Site, you agree to the
                terms of this Privacy Policy.
            </p>

            <h2>1. Information We Collect</h2>
            <p>
                We may collect information that you provide directly to us,
                such as when you contact us through our Contact page, as well
                as information collected automatically when you use the Site,
                including IP address, browser type, device information,
                referring URLs, pages visited, and timestamps. We may also
                use cookies and similar tracking technologies.
            </p>

            <h2>2. How We Use Information</h2>
            <p>
                We use the information we collect to operate, maintain, and
                improve the Site, to respond to inquiries, to measure the
                performance of editorial content and advertising, to comply
                with legal obligations, and to detect and prevent fraud or
                abuse.
            </p>

            <h2>3. Cookies & Tracking Technologies</h2>
            <p>
                Cookies are small text files placed on your device. We and
                our third-party partners (including advertising networks,
                affiliate networks, and analytics providers) may use cookies
                and similar technologies to recognize you, remember your
                preferences, measure performance, and serve relevant
                advertising. You can control cookies through your browser
                settings.
            </p>

            <h2>4. Affiliate Links & Third-Party Services</h2>
            <p>
                This Site contains affiliate links, including links to
                products listed on the ClickBank network. When you click an
                affiliate link and complete a qualifying action, we may earn
                a commission at no additional cost to you. Third-party sites
                you visit through our links have their own privacy policies,
                which we encourage you to review.
            </p>

            <h2>5. Sharing of Information</h2>
            <p>
                We do not sell personal information. We may share
                information with service providers who perform services on
                our behalf, with affiliate and advertising partners, when
                required by law, or in connection with a business transfer.
            </p>

            <h2>6. Your Choices</h2>
            <p>
                Depending on your location, you may have rights regarding
                your personal information, including the right to access,
                correct, delete, or restrict processing of your information.
                California residents may have additional rights under the
                CCPA/CPRA. To exercise these rights, contact us using the
                information on our Contact page.
            </p>

            <h2>7. Children's Privacy</h2>
            <p>
                The Site is intended for adults aged 18 and older. We do not
                knowingly collect personal information from children under
                13.
            </p>

            <h2>8. Data Security</h2>
            <p>
                We take reasonable steps designed to protect the information
                we collect. However, no method of transmission over the
                Internet or method of electronic storage is 100% secure.
            </p>

            <h2>9. Changes to This Policy</h2>
            <p>
                We may update this Privacy Policy from time to time. The
                updated version will be indicated by an updated "Last
                updated" date and will be effective as soon as it is posted.
            </p>

            <h2>10. Contact</h2>
            <p>
                For questions about this Privacy Policy, please use our{" "}
                <a href="/contact">Contact</a> page.
            </p>
        </LegalLayout>
        <Footer />
    </div>
    );
};

export default Privacy;
